module.exports = __webpack_public_path__ + "img/CAROUSEL_RICARICABILE_1920x450.3d3200c2.jpg";